module.exports = __webpack_public_path__ + "img/like.ab1beb6d.png";